import { render, staticRenderFns } from "./ConfigurationMenu.vue?vue&type=template&id=b58aa1b4&scoped=true"
import script from "./ConfigurationMenu.vue?vue&type=script&lang=js"
export * from "./ConfigurationMenu.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationMenu.vue?vue&type=style&index=0&id=b58aa1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58aa1b4",
  null
  
)

export default component.exports